<template>
  <el-card class="SubjectItem" shadow="hover">
    <slot name="moveBar"></slot>
    <div class="top" :class="{ 'max-height': !open }">
      <div class="title">
        <el-tag size="small" effect="plain" v-if="order">{{ order }}</el-tag>
        <el-tag size="small" effect="plain">{{ subject.typeAlias || getSubjectType(subject) }}</el-tag>
        <span class="subject-title" v-html="subject.title"></span>
      </div>
      <div class="top-right">
        <div>
          <span v-if="subject.scoreType === 1 && subject.score">{{subject.score}}分</span>
          <span v-if="subject.scoreType === 2">选项得分</span>
        </div>
        <div>
          <el-button v-if="showOpen" type="text" @click="open = !open">{{open ? '收起' : '展开'}}</el-button>
        </div>
      </div>
    </div>
    <div class="subject-content" v-if="open">
      <div class="media" v-if="['audio', 'video'].includes(subject.mediaType) && subject.files">
        <video v-if="subject.mediaType === 'video'" :src="getSrc" controls controlslist="nodownload" width="300"/>
        <audio v-if="subject.mediaType === 'audio'" :src="getSrc" controls controlslist="nodownload"/>
      </div>
      <div class="options" v-if="['single_choice', 'multiple_choice', 'true_false'].includes(subject.type)">
        <div class="option" v-for="(item, index) in subject.options">
          <span>{{item.content}}</span>
        </div>
      </div>
      <div class="options" v-if="subject.type === 'subjective'">
        <div class="subjective-option" v-for="(item, index) in getSubjectiveOptions">
          <div>{{item[0].content}}</div>
          <div class="mt6"><span class="mr10" v-for="score in item">{{score.scores[0].score}}</span></div>
        </div>
      </div>
      <div class="answer" v-if="subject.type !== 'case'">
        <div class="right">
          {{subject.scoreType === 1 && ['single_choice', 'multiple_choice', 'true_false'].includes(subject.type) ? '正确答案' : '题目解析'}}：
          <span>
            <template v-if="['single_choice', 'multiple_choice', 'true_false'].includes(subject.type) && subject.scoreType === 1">
              <template v-for="(item, index) in subject.options">
                <template v-if="item.correct">
                  {{orders[index]}}
                </template>
              </template>
            </template>
          </span>
        </div>
        <template v-if="['single_choice', 'multiple_choice', 'true_false'].includes(subject.type)">
          <div class="option-score" v-if="subject.scoreType === 2">
            <div v-for="(item, index) in subject.options">
              选项<span>{{orders[index]}}</span>选中时
              <template v-for="score in item.scores">
                ，维度【<span>{{getWd(score.wdcode)}}</span>】得<span>{{score.score}}</span>分
              </template>
            </div>
          </div>
        </template>
        <template v-if="subject.type === 'subjective'">
          <div class="option-score">
            <div>【<span>{{getSubjectiveOptions[0][0].content}}</span>】与【<span>{{getSubjectiveOptions[1][0].content}}</span>】为互斥选项</div>
            <div>【<span>{{getSubjectiveOptions[0][0].content}}</span>】得分代表维度【<span>{{getWd(getSubjectiveOptions[0][0].scores[0].wdcode)}}</span>】得分</div>
            <div>【<span>{{getSubjectiveOptions[1][0].content}}</span>】得分代表维度【<span>{{getWd(getSubjectiveOptions[1][0].scores[0].wdcode)}}</span>】得分</div>
          </div>
          <div class="option-score">
            <div v-for="(item, index) in getSubjectiveOptions[0]">
              【<span>{{item.content}}</span>】得<span>{{item.scores[0].score}}</span>分时，
              【<span>{{getSubjectiveOptions[1][getSubjectiveOptions[1].length - 1 - index].content}}</span>】得<span>{{getSubjectiveOptions[1][getSubjectiveOptions[1].length - 1 - index].scores[0].score}}</span>分
            </div>
          </div>
        </template>
        <div class="answer-des" v-else>
          {{subject.answer || '暂无'}}
        </div>
      </div>
      <template v-if="subject.type === 'case' && subject.children && subject.children.length">
        <subject-item
            class="subject-item-child"
            v-for="item in subject.children"
            :subject="item"
            :subjectTypeOptions="subjectTypeOptions"
            :wdList="wdList"
            :showOpen="false"
        />
      </template>
    </div>
    <template v-if="!subject.parent">
      <div class="tags" v-if="subject.tags">
        标签：<el-tag
            v-for="(item, index) in subject.tags.split(',')"
            size="medium"
            :type="['', 'success', 'info', 'warning', 'danger'][(index + 5) % 5]"
        >{{ item }}</el-tag>
      </div>
      <div class="bottom">
        <div class="left">
        <span>
          维度：{{getWd(subject.wdcodes)}}
        </span>
        </div>
        <div class="right">
          <slot name="controls"></slot>
        </div>
      </div>
    </template>
  </el-card>
</template>

<script>
import subject from '@/components/subject'
export default {
  name: "SubjectItem",
  components: {
    subject
  },
  props: {
    subject: {
      type: Object,
      default: () => ({})
    },
    subjectTypeOptions: {
      type: Array,
      default: () => []
    },
    wdList: {
      type: Array,
      default: () => []
    },
    order: {
      type: String
    },
    showOpen: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      open: !this.showOpen,
      orders: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
    };
  },
  computed: {
    getSubjectType() {
      return ({ type, mediaType }) => {
        let prefix = ''
        if (mediaType === 'audio') {
          prefix = '音频'
        } else if  (mediaType === 'video') {
          prefix = '视频'
        }
        let subjectType = this.subjectTypeOptions.find(v => v.metaCode === type)
        if (subjectType) {
          return `${prefix}${subjectType.metaName}`
        }
        return ''
      }
    },
    getWd() {
      return (wdcodes) => {
        if (!wdcodes) {
          return ''
        }
        let wdcodeList = wdcodes.split(',')
        return wdcodeList.map(item => {
          let wd = this.wdList.find(v => v.wdcode === item)
          if (wd) {
            return wd.wdname
          }
          return item
        }).join('，')
      }
    },
    getSubjectiveOptions() {
      if (this.subject.type !== 'subjective') {
        return []
      }
      let map = {}
      let newList = []
      let options = this.subject.options.sort(function(a, b) {
        if (a.groupNum === b.groupNum) {
          return a.scores[0].score - b.scores[0].score;
        }
        return a.groupNum - b.groupNum;
      })
      options.forEach((item, index) => {
        if (map[item.groupNum] || map[item.groupNum] === 0) {
          newList[map[item.groupNum]].push(item)
        } else {
          map[item.groupNum] = newList.length
          newList.push([item])
        }
      })
      return newList
    }
  },
  asyncComputed: {
    async getSrc () {
      if (this.subject.files) {
        let files = JSON.parse(this.subject.files)
        return await this.signatureUrl(files.name)
      }
    }
  },
  watch: {
  },
  mounted() {
  },
  methods: {
  }
};
</script>

<style scoped lang="scss">
.SubjectItem {
  position: relative;
  padding-right: 10px;
  margin-right: 10px;
  width: 100%;
  overflow: visible;
  ::v-deep .el-card__body {
    overflow: hidden;
  }
  ::v-deep .subject_item_mover {
    display: none;
    position: absolute;
    top: -6px;
    left: 2px;
    height: 24px;
    align-items: center;
    background-color: rgb(253, 236, 233);
    border-radius: 4px;
    z-index: 2;
    font-size: 16px;
    color: #E93C27;
    padding: 0 4px;
    cursor: move;
    span {
      margin-left: 4px;
      font-size: 12px;
      line-height: 24px;
    }
  }
  &:hover {
    ::v-deep .subject_item_mover {
      display: flex;
    }
  }
  .top {
    width: 100%;
    min-height: 26px;
    line-height: 26px;
    font-size: 14px;
    color: #606266;
    display: flex;
    overflow: hidden;
    &.max-height {
      max-height: 120px;
    }
    .title {
      flex: 1;
      span {
        margin-right: 6px;
      }
    }
    .top-right {
      width: 150px;
      padding-left: 40px;
      display: flex;
      justify-content: space-between;
      div {
        height: 26px;
        display: flex;
        align-items: center;
      }
      .el-button {
        height: 26px;
        display: flex;
        align-items: center;
        padding: 0;
      }
    }
  }
  .subject-content {
    .media {
      margin-top: 10px;
    }
    .options {
      margin-top: 10px;
      padding-left: 20px;
      .option {
        display: list-item;
        list-style-type: upper-latin;
        margin-bottom: 10px;
        font-size: 14px;
        color: #577688;
        &::marker {
          unicode-bidi: isolate;
          font-variant-numeric: tabular-nums;
          text-transform: none;
          text-indent: 0 !important;
          text-align: start !important;
          text-align-last: start !important;
        }
        span {
        }
      }
      .subjective-option {
        margin-bottom: 10px;
        margin-left: -20px;
        font-size: 14px;
        color: #577688;
        span {
        }
      }
    }
    .answer {
      padding-top: 15px;
      .right {
        font-size: 14px;
        color: #E93C27;
        span {
          font-weight: bold;
        }
      }
      .option-score {
        padding-top: 10px;
        color: #999;
        font-size: 14px;
        div {
          margin-top: 5px;
          span {
            color: #E93C27;
            padding: 0 4px;
          }
        }
      }
      .answer-des {
        padding-top: 10px;
        color: #999;
        font-size: 14px;
      }
    }
    .subject-item-child {
      margin-bottom: 10px;
    }
  }
  .tags {
    padding-top: 15px;
    color: #999;
    font-size: 14px;
    span {
      margin-right: 10px;
    }
  }
  .bottom {
    padding-top: 15px;
    display: flex;
    justify-content: space-between;
    .left {
      color: #999;
      font-size: 14px;
    }
    .right {
      color: #E93C27;
      font-size: 20px;
      ::v-deep i {
        margin-left: 16px;
        cursor: pointer;
      }
    }
  }
}
</style>
